import moment from "moment";
import StatusBadge from '../../Customers/StatusBadge';
import { formatDateForDisplay,formatCellValue } from "../../Utils/UtilityFunctions";
export const OrderListColumns = () => {
    const columns = [
        {
            accessorKey: 'id',
            header: 'Order ID ',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'customer',
            header: 'Customer',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'createdDate',
            header: 'Created Date',
            Cell: ({ cell }) => formatCellValue(cell.getValue(),val=> formatDateForDisplay(val))
        },
        {
            accessorKey: 'createdBy',
            header: 'Created by',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'amount',
            header: 'Amount',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'state',
            header: 'Status',
            Cell: ({ row, cell }) => {
                const validTo = row.original.validTo;
                const isExpired =moment(validTo).isValid() && moment(validTo).isBefore(moment(), "day");
                let statusValue = cell.getValue();
                statusValue=statusValue.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                if (validTo !== "0001-01-01T00:00:00Z" && isExpired) {
                    statusValue = "Inactive";
                }
                return <StatusBadge value={statusValue} />;
        }
        },
    ]
    return columns
}